<template>
  <a class="vkbutton"
    :class="[{plain, disabled, loading, round}, size]"
    :href="href"
    @click="onClick">
    <i class="vkloading"></i>
    <slot></slot>
  </a>
</template>

<style lang="less">
@import "../../styles/common.less";
a.vkbutton {
  display: block;
  position: relative;
  height: 0.4rem;
  line-height: 0.36rem;
  padding: 0 0.1rem;
  font-size: 0.16rem;
  font-family: var(--textM);
  text-align: center;
  color: var(--btn-fontcolor);
  border: 2px solid var(--btn-normal, #F85415);
  background-color: var(--btn-normal, #F85415);
  border-radius: 0.08rem;
  transition: all 0.3s;
  cursor: pointer;
  box-sizing: border-box;
  &.round {
    border-radius: 0.19rem;
  }
  .noselect();

  .vkloading {
    display: none;
  }
  &.small {
    height: 0.34rem;
    line-height: 0.3rem;
    padding: 0 0.08rem;
    font-size: 0.15rem;
    border-radius: 0.07rem;

    &.round {
      border-radius: 0.17rem;
    }
  }

  &.tiny {
    height: 0.3rem;
    line-height: 0.27rem;
    padding: 0 0.06rem;
    font-size: 0.14rem;
    border-radius: 0.07rem;

    &.round {
      border-radius: 0.15rem;
    }
  }

  &.mini {
    height: 0.26rem;
    line-height: 0.23rem;
    padding: 0 0.04rem;
    font-size: 0.12rem;
    border-radius: 0.06rem;

    &.round {
      border-radius: 0.13rem;
    }
  }

  &:hover {
    background-color: var(--btn-hover, #FFB300);
    border-color: var(--btn-hover, #FFB300);
  }

  &.plain {
    background-color: #fff;
    color: var(--btn-normal, #F85415);
    border-color: var(--btn-plain, #F85415);
    box-shadow: none;

    &:hover {
      border-color: var(--btn-hover, #FFB300);
      color: var(--btn-hover, #FFB300);
    }
  }

  // 禁用状态
  &.disabled {
    background-color: var(--btn-disable, #FFF082);
    border-color: var(--btn-disable, #FFF082);
    color: var(--btn-disablefontcolor, #fff);
    cursor: not-allowed;

    &:hover {
      background-color: var(--btn-disable, #FFF082);
      border-color: var(--btn-disable, #FFF082);
    }

    &.plain, &.plain:hover {
      background-color: #fff;
      border-color: var(--btn-disable, #FFF082);
      color: var(--btn-disable, #FFF082);
    }
  }

  // Loading状态
  &.loading {
    background-color: var(--btn-disable, #FFF082);
    border-color: var(--btn-disable, #FFF082);
    color: var(--btn-disablefontcolor);
    cursor: wait;
    padding-left: 0.25rem !important;

    .vkloading {
      .loading-white(100%, 100%);
      position: absolute;
      left: 0.08rem;
      top: 50%;
      display: block;
      width: 0.12rem;
      height: 0.12rem;
      margin-top: -0.06rem;
    }

    &:hover {
      background-color: var(--btn-disable, #FFF082);
      border-color: var(--btn-disable, #FFF082);
    }

    &.plain, &.plain:hover {
      background-color: #fff;
      border-color: #FDDCD0;
      color: var(--btn-disable, #FFF082);
      .vkloading {
        .loading-red();
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    // medium / small / tiny / mini
    size: {
      type: String,
      default: 'medium',
    },
    // 是否朴素模式（类似element-ui的按钮plain属性）
    plain: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 圆角
    round: {
      type: Boolean,
      default: false,
    },
    // 是否loading状态（loading状态也可点击）
    loading: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      default: null,
    },
    vkdata: {
      type: Array,
      default: () => [],
    },
    behavior: {
      type: String,
      default: 'pageTo',
    },
    target: {
      type: String,
      default: '_self',
    },
  },
  methods: {
    onClick(e) {
      if (!this.disabled && !this.loading) {
        this.$emit('click', e);
        if (this.tag) {
          this.$log.tag(this.tag, ...this.vkdata);
        }

        if (this.behavior) {
          e.preventDefault();
          if (this.href) {
            if (this.target === '_blank') {
              window.open(this.href);
            } else {
              this.$app[this.behavior](this.href).then(event => this.$emit('behavior', event));
            }
          }
        }
      } else {
        e.preventDefault();
      }
    },
  },
};
</script>
